import { useReactFlow, type Node } from "@xyflow/react";
import { useCallback } from "react";

type UpdateNodeData<T extends Node> = (node: Partial<T["data"]>) => void;

export const useUpdateNodeData = <T extends Node>(nodeId: string): UpdateNodeData<T> => {
    const reactFlowInstance = useReactFlow();
    return useCallback(
        (update: Partial<Node["data"]>) => {
            reactFlowInstance.setNodes((nodes) =>
                nodes.map((n) => (n.id === nodeId ? { ...n, data: { ...n.data, ...update } } : n)),
            );
        },
        [nodeId, reactFlowInstance],
    );
};
